import { FileboxOperationEnum } from '../enums/filebox-operation.enum';

/**
 * Lease filebox record DTO
 */
export class LeaseFileboxRecordDto {
	tenantOrgId!: string;
	synchronizationToken!: string;
	fileUuid!: string;
	operation!: FileboxOperationEnum;
}
